if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            this.buildCharweeDrawerLayout();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      buildCharweeDrawerLayout() {
        const product = this.modalContent.querySelector('.product');
        const info = this.modalContent.querySelector('.product__info-container');
        const widgets = info?.querySelector('.charwee-widgets');
        const variantPicker = widgets?.querySelector('variant-radios, variant-selects');
        const quantity = widgets?.querySelector('.product-form__quantity');
        const buttonGroup = widgets?.querySelector('.button-full-width');
        const detailsLink = widgets?.querySelector('.product__view-details');
        const price = info?.querySelector('[id^="price-"]');
        const tax = info?.querySelector('.product__tax');

        if (!product || !info || !widgets || !variantPicker || !quantity || !buttonGroup || !price) return;

        product.classList.add('charwee-quick-drawer');
        info.querySelectorAll('.shopify-app-block, .cw-inline, .cw-trust, #live-purchase').forEach((element) => {
          element.remove();
        });

        const purchaseRow = document.createElement('div');
        purchaseRow.className = 'charwee-quick-drawer__purchase-row';
        const priceGroup = document.createElement('div');
        priceGroup.className = 'charwee-quick-drawer__price-group';
        priceGroup.appendChild(price);

        if (tax) {
          tax.textContent = 'Inclusive of all taxes';
          priceGroup.appendChild(tax);
        }

        purchaseRow.append(priceGroup, quantity);
        widgets.insertBefore(purchaseRow, variantPicker);

        const delivery = document.createElement('div');
        delivery.className = 'charwee-quick-drawer__delivery';
        const deliveryIcon = document.createElement('span');
        deliveryIcon.className = 'charwee-quick-drawer__delivery-icon';
        deliveryIcon.setAttribute('aria-hidden', 'true');
        deliveryIcon.textContent = '⚡';
        const deliveryTitle = document.createElement('strong');
        deliveryTitle.textContent = 'EXPRESS DELIVERY';
        const deliveryCopy = document.createElement('span');
        deliveryCopy.textContent = '– on prepaid orders only*';
        delivery.append(deliveryIcon, deliveryTitle, deliveryCopy);
        purchaseRow.insertAdjacentElement('afterend', delivery);

        const legend = variantPicker.querySelector('legend');
        const optionTitles = Array.from(variantPicker.querySelectorAll('.custom-variant-title'));
        optionTitles.forEach((title) => {
          const match = title.textContent.match(/Pack of\s*\d+/i);
          if (match) title.textContent = match[0];
        });

        if (legend) {
          legend.textContent = '';
          const legendTitle = document.createElement('strong');
          legendTitle.textContent = 'Pack Size:';
          const selected = document.createElement('span');
          selected.className = 'charwee-quick-drawer__selected-pack';
          const updateSelectedPack = () => {
            const checked = variantPicker.querySelector('input[type="radio"]:checked');
            const match = checked?.value.match(/Pack of\s*\d+/i);
            selected.textContent = match ? ` ${match[0]}` : '';
          };
          legend.append(legendTitle, selected);
          variantPicker.addEventListener('change', updateSelectedPack);
          updateSelectedPack();
        }

        if (detailsLink) widgets.insertBefore(buttonGroup, detailsLink);
        const oldButtonRow = widgets.querySelector('.button-flex');
        if (oldButtonRow && oldButtonRow.children.length === 0) oldButtonRow.remove();

        const mediaWrapper = product.querySelector('.product__media-wrapper');
        const mediaImages = Array.from(product.querySelectorAll('.product__media-item img'));
        if (mediaWrapper && mediaImages.length) {
          const gallery = mediaImages.map((image) => ({
            src: image.currentSrc || image.src,
            srcset: image.srcset,
            alt: image.alt,
          }));
          let activeIndex = 0;

          const hero = document.createElement('div');
          hero.className = 'charwee-quick-drawer__hero';
          const heroImage = document.createElement('img');
          heroImage.className = 'charwee-quick-drawer__hero-image';
          heroImage.loading = 'eager';
          hero.appendChild(heroImage);
          mediaWrapper.insertAdjacentElement('beforebegin', hero);
          mediaWrapper.hidden = true;

          const nav = document.createElement('div');
          nav.className = 'charwee-quick-drawer__gallery-nav';
          const previous = document.createElement('button');
          previous.type = 'button';
          previous.className = 'charwee-quick-drawer__gallery-arrow';
          previous.setAttribute('aria-label', 'Previous product image');
          previous.textContent = '‹';
          const dots = document.createElement('div');
          dots.className = 'charwee-quick-drawer__gallery-dots';
          const next = document.createElement('button');
          next.type = 'button';
          next.className = 'charwee-quick-drawer__gallery-arrow';
          next.setAttribute('aria-label', 'Next product image');
          next.textContent = '›';

          const updateGallery = (index) => {
            activeIndex = (index + gallery.length) % gallery.length;
            const image = gallery[activeIndex];
            heroImage.src = image.src;
            if (image.srcset) heroImage.srcset = image.srcset;
            heroImage.alt = image.alt;
            dots.querySelectorAll('button').forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === activeIndex);
              dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
            });
          };

          if (gallery.length > 1) {
            gallery.forEach((image, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.setAttribute('aria-label', `Show product image ${index + 1}`);
              dot.addEventListener('click', () => updateGallery(index));
              dots.appendChild(dot);
            });
            previous.addEventListener('click', () => updateGallery(activeIndex - 1));
            next.addEventListener('click', () => updateGallery(activeIndex + 1));
            nav.append(previous, dots, next);
            hero.insertAdjacentElement('afterend', nav);
          } else {
            hero.classList.add('charwee-quick-drawer__hero--single');
          }
          updateGallery(0);
        }
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
